import { ChevronRight } from 'lucide-react'
import { useState } from 'react'

interface NavItemProps {
  item: {
    name: string
    href?: string
    icon: any
    current: boolean
    children?: { name: string; href: string }[]
  }
  currentPath: string
  onNavigate: (path: string) => void
}

export const NavItem = ({ item, currentPath, onNavigate }: NavItemProps) => {
  const [isExpanded, setIsExpanded] = useState(item.current)
  
  const Icon = item.icon
  
  if (item.children) {
    return (
      <div className="space-y-1">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={`flex items-center justify-between w-full p-2 rounded-lg transition-colors ${
            item.current ? 'bg-primary/10 text-primary' : 'hover:bg-accent'
          }`}
        >
          <div className="flex items-center space-x-3">
            <Icon className="w-5 h-5" />
            <span className="font-medium">{item.name}</span>
          </div>
          <ChevronRight 
            className={`w-4 h-4 transition-transform ${
              isExpanded ? 'rotate-90' : ''
            }`} 
          />
        </button>
        
        {isExpanded && (
          <div className="ml-4 space-y-1">
            {item.children.map((child) => (
              <button
                key={child.href}
                onClick={() => onNavigate(child.href)}
                className={`flex items-center w-full p-2 rounded-lg transition-colors text-sm ${
                  currentPath === child.href 
                    ? 'bg-primary/20 text-primary font-medium' 
                    : 'text-muted-foreground hover:bg-accent hover:text-foreground'
                }`}
              >
                {child.name}
              </button>
            ))}
          </div>
        )}
      </div>
    )
  }
  
  return (
    <button
      onClick={() => item.href && onNavigate(item.href)}
      className={`flex items-center space-x-3 w-full p-2 rounded-lg transition-colors ${
        item.current ? 'bg-primary/10 text-primary' : 'hover:bg-accent'
      }`}
    >
      <Icon className="w-5 h-5" />
      <span className="font-medium">{item.name}</span>
    </button>
  )
}
